import styled from "styled-components";

const Wrapper = styled.div`
  margin-top: 10px;
  width: 100%;
`;
export default Wrapper;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  line-height: 1.8;
  color: var(--color-dark);
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    color: var(--app-color-dark);
  }
  .special {
    color: #ccd4d6;
    margin-left: 7px;
  }
`;

export const Input = styled.div`
  position: relative;
  input {
    border: 1px solid #e8e8e8;
    border-radius: 5px;
    padding: 13px;
    font-size: 17px;
    font-weight: 400;
    color: var(--color-dark);
    width: 100%;
    outline: none;
    ::placeholder {
      color: #ccd4d6;
    }
    :hover {
      border: 1px solid var(--app-color-dark);
      box-shadow: -1px 0px 8px 3px rgb(90 179 168 / 62%);
    }
  }
  button {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    outline: none;
    font-size: 25px;
    background: transparent;
    cursor: pointer;
    color: #ccd4d6;
  }
  svg {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    outline: none;
    font-size: 25px;
    background: transparent;
    cursor: pointer;
    color: var(--color-dark);
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  resize: none;
  min-height: 100px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  outline: none;
  font-size: 17px;
  font-weight: 400;
  color: var(--color-dark);
  padding: 10px;
  font-family: "Times New Roman", Times, serif;
`;

export const Toggle = styled.div`
.form-check {
    display: flex;
    justify-content: space-between;

    .span {
      font-family: 'Lato';
      font-weight: 600;
      font-size: 12px;
      vertical-align: middle;
      line-height: 2;
    }
  }
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}`